jQuery(window).load(function() {
	
	 jQuery('.off-canvas-wrapper').addClass('loaded');
	 
	 //slide in elements
	// jQuery('.off-canvas-content').children().addClass('animated');
	 //jQuery('.off-canvas-content').children().addClass('fadeIn');	
	      
});
